import { render } from "./AccessRequestListItem.vue?vue&type=template&id=5cbcf88e"
import script from "./AccessRequestListItem.vue?vue&type=script&lang=js"
export * from "./AccessRequestListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__